import { Subscription } from "rxjs";
import { SecurityQuestionsService } from "./service/securityQuestions.service";
import { Router } from "@angular/router";
import { Component, Input, OnInit } from "@angular/core";
import { BehavioralService } from "./service/behavioral.service";
import {
  IQuestionAnswer,
  IQuestionAnswerArray,
} from "./model/question.answer.model";
import { IQuestionType, IQuestionRequest } from "./model/question.model";
import { IClaimResponse, IClaimRequest } from "./model/claim.model";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

@Component({
  templateUrl: "./template/securityQuestions.component.html",
})
export class SecurityQuestionListComponent implements OnInit {
  step1 = true;
  step2 = false;
  step3 = false;

  mouseoverLogin;
  questions: IQuestionType[];
  answer;
  questionAnswerArr: IQuestionAnswer[] = [];
  disabledFlag = false;
  claim: IClaimResponse;
  claimRequest: IClaimRequest;
  $subs: Subscription;
  maxSelectLength: number;
  selectLength: any[] = [0, 1, 2];
  form: FormGroup;
  questionFormControl0 = new FormControl(null, Validators.required);
  questionFormControl1 = new FormControl(null, Validators.required);
  questionFormControl2 = new FormControl(null, Validators.required);

  answerFormControl0 = new FormControl(null, Validators.required);
  answerFormControl1 = new FormControl(null, Validators.required);
  answerFormControl2 = new FormControl(null, Validators.required);

  selectedTargets: any;
  questionsSelect = [];

  constructor(
    private router: Router,
    private behavioralService: BehavioralService,
    private securityQuestionsService: SecurityQuestionsService,
    private fb: FormBuilder
  ) {}

  ngOnDestroy(): void {
    this.$subs.unsubscribe();
  }
  ngOnInit() {
    this.form = this.fb.group({
      questionFormControl0: this.questionFormControl0,
      questionFormControl1: this.questionFormControl1,
      questionFormControl2: this.questionFormControl2,

      answerFormControl0: this.answerFormControl0,
      answerFormControl1: this.answerFormControl1,
      answerFormControl2: this.answerFormControl2,
    });

    this.$subs = this.behavioralService.receiveClaimData().subscribe((d) => {
      this.claim = d;

      /* {
        "status": "Valid",
        "errors": "",
        "raw_value": "{Status=Valid, UserName=anh.testworkday, errors=}",
        "user_name": "anh.testworkday"
      }*/
    });

    // Use the localStorage Claim data for claimRequest (if present)
    if(localStorage.getItem('claimIdentity')){
      let ls_claimIdentity = localStorage.getItem('claimIdentity')
      this.claimRequest = JSON.parse(ls_claimIdentity);
    } else {

      this.$subs = this.behavioralService
        .receiveClaimRequestData()
        .subscribe((d) => {
          this.claimRequest = d;
          /*{
          "first_name": "Anh",
          "last_name": "TestWorkday",
          "claim_code": "***********",
          "user_type": "employee"
        }*/
        });
    }

    this.securityQuestionsService
      .getSecurityQuestions(this.buildQuestionRequest())
      .subscribe((questions) => {
        this.questions = questions.result;
        //this.mockedQuestions
        this.questions.forEach((v) => {
          this.questionsSelect.push({ key: v.question, label: v.question });
        });

        this.questionsSelect.forEach((val, i) => {
          this["originalQuestions" + i] = this.questionsSelect;
        });

        this.maxSelectLength = this.questions.length;
        this.questionFormControl0.patchValue(this.questions[0].question);
        this.questionFormControl1.patchValue(this.questions[1].question);
        this.questionFormControl2.patchValue(this.questions[2].question);
      });
  }

  buildQuestionRequest(): IQuestionRequest {
    let request: IQuestionRequest = {
      workflow_arg: "all",
      user_type: this.claimRequest.user_type,
    };
    return request;
  }

  submitAnswersStep1(formValues) {
    if (this.validateForm()) {
      this.step1 = false;
      this.step2 = true;
    } else {
      this.disabledFlag = this.validateForm();
    }
  }

  submitAnswersStep2() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = true;
  }

  submitAnswersStep3() {
    this.step1 = false;
    this.step2 = false;
    this.step3 = false;
    this.behavioralService.sendQAList(this.questionAnswerArr);

    this.router.navigate(["identityiq/external/setPassword"]);
  }

  validateForm() {
    return this.questionAnswerArr.length >= 3;
  }
  saveAnswer() {
    this.questionAnswerArr = [];

    this.selectLength.forEach((val, i) => {
      if (
        this.form.get("questionFormControl" + i)?.value &&
        this.questions[i]?.id &&
        this.form.get("answerFormControl" + i)?.value
      ) {
        let questionAnswer: IQuestionAnswer = {
          question: this.form.get("questionFormControl" + i)?.value,
          id: this.questions.find(x => x.question === this.form.get("questionFormControl" + i)?.value).id,
          answer: this.form.get("answerFormControl" + i)?.value,
        };
        this.questionAnswerArr.push(questionAnswer);
      }

      /*if (!this.idExists(questionAnswer.id)) {
        this.questionAnswerArr.push(questionAnswer)
      } */
    });

    this.disabledFlag = this.validateForm();
  }

  idExists(id) {
    return this.questionAnswerArr.some(function (el) {
      return el.id === id;
    });
  }

  addItemFormControl() {
    if (
      this.form.get("questionFormControl" + (this.selectLength.length - 1))
        ?.value === ""
    ) {
      this.form
        .get("questionFormControl" + (this.selectLength.length - 1))
        .setValue(
          this["originalQuestions" + (this.selectLength.length - 1)][0].question
        );
    }

    this.form.addControl(
      "questionFormControl" + this.selectLength.length,
      new FormControl(null)
    );

    this.form.addControl(
      "answerFormControl" + this.selectLength.length,
      new FormControl(null)
    );

    this["originalQuestions" + this.selectLength.length] =
      this.questionsSelect.filter(
        (val) => !Object.values(this.form.value).includes(val.key)
      );
    this.selectLength.push(this.selectLength.length);
  }

  removeItemFormControl(i) {
    this.selectLength.forEach((a) => {
      this["originalQuestions" + a] = this["originalQuestions" + a].filter(
        (a) => a !== this.form.get("questionFormControl" + i)
      );
    });
    this.form.removeControl("questionFormControl" + i);

    this.form.removeControl("answerFormControl" + i);
    this.selectLength.pop();
  }

  AddTarget(index, value) {
    let count = 0;
    Object.values(this.form.value).forEach((element) => {
      if (element === value) {
        count++;
      }
      if (count > 1) {
        this.form.get("questionFormControl" + index).setValue(null);
      }
    });

    /**  Cleanup options  */
    /*this.selectLength.forEach(val => {
      this['originalQuestions' + val] = this.questions.filter(val => !Object.values(this.form.value).includes(val.question));
    })*/
  }

  onChange(FormControl) {
    let count = 0;
    Object.values(this.form.value).forEach((element) => {
      if (element === FormControl?.value) {
        count++;
      }
      if (count > 1) {
        FormControl.setValue(null);
      }
    });
  }

  getQuestions(i) {
    return this["originalQuestions" + i];
  }

  getQuestionFormControl(i) {
    return this.form.get("questionFormControl" + i);
  }
}
